import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="section-container">
        {/* Top section */}
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 4L26 12L34 14L28 22L29 30L20 27L11 30L12 22L6 14L14 12L20 4Z"
                      stroke="currentColor" strokeWidth="1.5" fill="none"/>
                <circle cx="20" cy="18" r="4" stroke="currentColor" strokeWidth="1"/>
              </svg>
              <div>
                <span className="footer__logo-name">Paradise Events</span>
                <span className="footer__logo-tagline">Krijimi i momenteve magjike</span>
              </div>
            </div>
            <p className="footer__brand-desc">
              Kompania lidere e planifikimit te eventeve ne Kosove.
              Transformojme cdo moment ne dicka te jashtezakonshme.
            </p>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__links-title">Navigimi</h4>
            <div className="footer__links">
              {['Kryefaqja', 'Rreth Nesh', 'Sherbimet', 'Galeria', 'Kontakti'].map((link) => (
                <a key={link} href={`#${link.toLowerCase().replace(' ', '-')}`} className="footer__link">
                  {link}
                </a>
              ))}
            </div>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__links-title">Sherbimet</h4>
            <div className="footer__links">
              {['Organizim Dasmash', 'Dekorim & Dizajn', 'Fishekzjarre', 'Fotografi & Video', 'Evente Korporative'].map((link) => (
                <a key={link} href="#services" className="footer__link">
                  {link}
                </a>
              ))}
            </div>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__links-title">Na Ndiqni</h4>
            <div className="footer__socials">
              <a
                href="https://www.instagram.com/paradise.eventt/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social"
                aria-label="Instagram"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="2" y="2" width="20" height="20" rx="5" />
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
                  <circle cx="17.5" cy="6.5" r="1.5" />
                </svg>
              </a>
              <a
                href="https://wa.me/38349343079"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social"
                aria-label="WhatsApp"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                  <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 01-4.243-1.214l-.293-.175-3.041.798.813-2.97-.192-.304A8 8 0 1112 20z" />
                </svg>
              </a>
              <a href="tel:+38349343079" className="footer__social" aria-label="Phone">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                </svg>
              </a>
            </div>
            <div className="footer__contact-info">
              <p>+383 49 343 079</p>
              <p>Rr. Enver Haradinaj</p>
              <p>Pristina 10000, Kosovo</p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; {currentYear} Paradise Events. Te gjitha te drejtat e rezervuara.
          </p>
          <p className="footer__credit">
            Created by{' '}
            <a
              href="https://nexoraagency.llc"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__credit-link"
            >
              nexoraagency.llc
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
